import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

export const TrialBalanceExportModal = ({
  initialFrom,
  initialTo,
  isOpen,
  onApplyCustomRange,
  onClose,
}) => {
  const toast = useToast();
  const [fromDate, setFromDate] = useState(initialFrom);
  const [toDate, setToDate] = useState(initialTo);

  useEffect(() => {
    setFromDate(initialFrom);
    setToDate(initialTo);
  }, [initialFrom, initialTo]);

  const handleApply = () => {
    if (!fromDate || !toDate) {
      toast({
        title: "Validation Error",
        description: "Both From* and To* dates are required.",
        status: "error",
        duration: 3000,
      });
      return;
    }

    if (new Date(fromDate) > new Date(toDate)) {
      toast({
        title: "Date Error",
        description: "The 'From' date cannot be after the 'To' date.",
        status: "warning",
        duration: 4000,
      });
      return;
    }

    onApplyCustomRange({ from_date: fromDate, to_date: toDate });
    onClose();
  };

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Custom range</ModalHeader>
        <ModalBody>
          <HStack spacing={4}>
            <FormControl isRequired>
              <FormLabel fontSize="sm">From*</FormLabel>
              <Input
                size="sm"
                type="date"
                value={fromDate}
                onChange={(event) => setFromDate(event.target.value)}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">To*</FormLabel>
              <Input
                size="sm"
                type="date"
                value={toDate}
                onChange={(event) => setToDate(event.target.value)}
              />
            </FormControl>
          </HStack>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} size="sm" variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleApply} size="sm">
            Apply
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
